import { Chart } from "chart.js/auto";

// Registrar todos los componentes necesarios, incluidas las escalas

angular.module("events")

    .controller('EventsResumeListCtrl', ['event', 'gridService', '$rootScope', '$scope', '$filter', 'LoginService', 'Restangular', '$stateParams', 'treeService', '$interval', '$http', 'filterFilter', 'modalService', '$timeout', 'datasetsService', 'logService',
        function (event, gridService, $rootScope, $scope, $filter, LoginService, Restangular, $stateParams, treeService, $interval, $http, filterFilter, modalService, $timeout, datasetsService, logService) {

        $scope.totalRow = 0;
        $scope.invitedGuestNotInYet = 0;
        $scope.filterGuestsIn = 0;
        $scope.filterGuestsRejected = 0;
        $scope.totalGuestNotInYet = 0;
        $scope.totalGuestIn = 0;

        let barOptions = {
            scaleBeginAtZero: true,
            scaleShowGridLines: true,
            scaleGridLineColor: "rgba(0,0,0,.05)",
            scaleGridLineWidth: 1,
            barShowStroke: true,
            barValueSpacing: 5,
            barDatasetSpacing: 0,
            scaleOverride: true,
            scaleSteps: 10,
            scaleStartValue: 0,
            responsive: true,
            maintainAspectRatio: false,
            scales: {
                x: {
                    stacked: true,
                    grid: {
                        color: "rgba(0, 0, 0, 0)",
                    }
                },
                y: {
                    min: 0,
                    stacked: true,
                    grid: {
                        color: "rgba(0, 0, 0, 0)",
                    },
                    ticks: {
                        beginAtZero: true,
                        callback: function (value) {
                            if (Math.floor(value) === value) {
                                return value;
                            };
                        }
                    },
                }
            }
        };

        function isDefinedAndNotNull(val) {
            return angular.isDefined(val) && val !== null
        }
        function isDefinedAndNotNullOrEmpty(val) {
            return angular.isDefined(val) && val !== null && val !== ""
        }

        $rootScope.title = $filter('translate')('events.resume.monitoring');
        $rootScope.breadcrumb = [
            { title: $filter('translate')('events.title'), url: "events.list" },
            { title: $filter('translate')('events.title'), url: "events.list" },
            { title: $filter('translate')('events.resume.monitoring') }
        ];

        $rootScope.is_template = event.is_template;
        $scope.event = event;
        $scope.event.date_from = new Date($scope.event.date_from);
        $scope.event.date_to = new Date($scope.event.date_to);
        $scope.searchOptions = { date: $scope.event.date_from };
            
        // Sacar el listado de actos del evento 
        let mainEvent = { plain_text_name: $filter('translate')('events.main_event'), isMainEvent: true, id: 0 };
        $scope.selectedAct = mainEvent;

        $scope.loadActList = function () {

            let params = { allow_access_control: true, event_id: event.id, parse_text: true }
            Restangular.all('EventsProgramsActs/GetEventConfirmableActs').getList(params).then(function (results) {

                $scope.actList = results;
                $scope.actList.push(mainEvent); 

                logService.debug('loadActList results...')
                logService.debug($scope.actList);

                $scope.loadChart(); // Hay que al intervalo

            });

        }

            $scope.loadActList();

            $scope.setOptionsDate = function () {
                const isMainEvent = $scope.selectedAct.isMainEvent; 
                if (isMainEvent) {
                    $scope.searchOptions.date = $scope.event.date_from;
                } else {
                    if ($scope.selectedAct.date) $scope.searchOptions.date = new Date($scope.selectedAct.date);
                }
            }

        $rootScope.breadcrumb = [
           { title: $filter('translate')('events.title'), url: "events.list" },
            { title: $scope.event.name, url: "events.edit({ id: " + $scope.event.id + " })" },
           { title: $filter('translate')('events.resume.monitoring') }
        ];

        $scope.getGuestFilters = function (guests, type) {
            if (type == 'notin') {
                var res = filterFilter(guests, { confirmation_status: 'confirmed' });
                return filterFilter(res, { check_in_date: null }).length;
            } else if (type == 'in') {
                var res = filterFilter(guests, { confirmation_status: 'confirmed' });
                return filterFilter(res, { check_in_date: '!!' }).length;
                //return filterFilter(guests, { confirmation_status: 'confirmed' } && { check_in_date: '!!' }).length; NO SE PONE ASI PORWUE NO LE GUSTA MAS DE UN FILTRO.
            } else {
                var res = filterFilter(guests, { confirmation_status: '!confirmed' });
                return filterFilter(res, { check_in_date: '!!' }).length;
                //return filterFilter(guests, { confirmation_status: '!confirmed' } && { check_in_date: '!!' }).length; NO SE PONE ASI PORWUE NO LE GUSTA MAS DE UN FILTRO.
            }
        }

        $scope.getSerieColor = function (i) {

            var colors = [

                "#ff7f27",
                "rgba(151,187,205,1)",
                "rgba(220,220,220,1)",
                "rgba(247,70,74,1)",
                "rgba(70,191,189,1)",
                "rgba(253,180,92,1)",
                "rgba(148,159,177,1)",
                "rgba(77,83,96,1)"

            ];

            if (i >= colors.length) i = 0;
            return colors[i];

        };

          //  Restangular.all('EventsProgramsActs').customGET("GetGuestsAct", { event_program_act_id: event_program_act_id }).then(function (results) { });

            $scope.loadChart = function () {

                let params;
                let endpoint;
                const isMainEvent = $scope.selectedAct.isMainEvent; 

                if (isMainEvent) {

                     params = {
                        event_id: $stateParams.id,
                         date: $scope.searchOptions.date
                    }

                     endpoint = 'Events/getActualEventInfo/';

                } else {

                     params = {
                        event_program_act_id: $scope.selectedAct.id
                    }

                     endpoint = 'EventsProgramsActs/GetGuestsAct/';

                }

                $http({
                    method: 'get',
                    url: (window as any).CONFIG.api_url + endpoint,
                    params: params
                }).then(function (response, status, headers, config) {

                    let results = response.data.rows ? response.data.rows : response.data;
                    
                    /// let searchDate = isMainEvent ? new Date($scope.searchOptions.date) : new Date($scope.selectedAct.date);

                    let searchDate = new Date($scope.searchOptions.date);

                    let parsedDate = `${searchDate.getDate()}/${searchDate.getMonth() + 1}/${searchDate.getFullYear()}`;

                    let dataResults = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];

                    //Filtramos los invitados que han accedido al evento

                    let data = results.filter(r => r.check_in_date);

                    // Les añadimos los datos relevantes 

                    data.forEach(d => {
                        let date = new Date(d.check_in_date);
                        d.hour = date.getHours(); //date.getUTCHours(); //   No sé por qué representamos en UTC
                        d.date = `${date.getDate()}/${date.getMonth() + 1 }/${date.getFullYear()}`; // `${date.getUTCDate()}/${date.getUTCMonth()}/${date.getUTCFullYear()}`;
                    });

                    // Aplicamos el filtro de fecha
                    let filteredData = data.filter(d => d.date == parsedDate);

                    // Rellenamos los datos de la gráfica
                    filteredData.forEach(d => {
                        dataResults[d.hour] = dataResults[d.hour] + 1;
                    });

                    var barData = {
                        labels: ["0h", "1h", "2h", "3h", "4h", "5h", "6h", "7h", "8h", "9h", "10h", "11h", "12h", "13h", "14h", "15h", "16h", "17h", "18h", "19h", "20h", "21h", "22h", "23h"],
                        datasets: [{
                            label: "Número de asistentes",
                            data: dataResults,
                            backgroundColor: `#23c6c8`
                        }]
                    };

                    if ($scope.myNewChart != null) {

                        $scope.myNewChart.destroy();

                    }

                    const canvas = document.getElementById("barChart") as HTMLCanvasElement;
                    const ctx = canvas.getContext("2d");

                    $scope.myNewChart = new Chart(ctx, {
                        type: "bar",
                        data: barData,
                        options: barOptions
                    });

                });

            };

       $scope.loadGuests = function () {

            let params;
            let endpoint;
            const isMainEvent = $scope.selectedAct.isMainEvent;

            if (isMainEvent) {

                params = {
                    event_id: $stateParams.id,
                    date: $scope.searchOptions.date, 
                }

                endpoint = 'Events/getActualEventInfo/';

            } else {

                params = {
                    event_program_act_id: $scope.selectedAct.id
                }

                endpoint = 'EventsProgramsActs/GetGuestsAct/';

            }

            $http({
                method: 'get',
                url: (window as any).CONFIG.api_url + endpoint,
                params: params
            }).then(function (results, status, headers, config) {

                $scope.invitedGuests = results.data.rows ? results.data.rows : results.data;

                $scope.totalRow = results.data.totalRow;
                $scope.invitedGuestNotInYet = $scope.getGuestFilters($scope.invitedGuests, 'notin');
                $scope.filterGuestsIn = $scope.getGuestFilters($scope.invitedGuests, 'in');
                $scope.filterGuestsRejected = $scope.getGuestFilters($scope.invitedGuests, 'rejected');
                $scope.totalGuestNotInYet = ($scope.invitedGuestNotInYet / ($scope.invitedGuestNotInYet + $scope.filterGuestsIn) * 100);
                $scope.totalGuestIn = ($scope.filterGuestsIn / ($scope.invitedGuestNotInYet + $scope.filterGuestsIn) * 100);

            });
        }

        $scope.loadGuests();

        let intervalLoadInfoDashboard = $interval(function () { $scope.loadGuests(); $scope.loadChart(); }, (window as any).CONFIG.time_check_changes_guests);

            const changeAssistance = function (item, route) {

                Restangular.all("EventsResume").customGET("CheckCompanions", { event_id: $stateParams.id, events_guests_ids: [item.person_id] }).then(function (has_companions) {

                const isMainEvent = $scope.selectedAct.isMainEvent; 

                let container;

                if (isMainEvent) {

                    container = {
                        event_id: $stateParams.id,
                        list: [item.person_id],
                        check_companions: has_companions,
                        overrideDate: item.check_in_date != null ? item.check_in_date : $scope.searchOptions.date,
                    };

                } else {

                     container = {
                         id: item.id,
                         overrideDate: $scope.searchOptions.date,
                         check_companions: has_companions,
                    }

                    route += "Acts";

                }

                if (has_companions) {
                    modalService.confirm({
                        title: $filter('translate')('events.guests.warning'),
                        message: $filter('translate')('events.resume.has_companions'),
                        onAccept: function () {
                            change(container, route);
                        },
                        onCancel: function () {
                            container.check_companions = false;
                            change(container, route);
                        }
                    });
                } else {
                    change(container, route);
                }
            });

        }

            var change = function (container, route) {
                const isMainEvent = $scope.selectedAct.isMainEvent; 
            $timeout(function () {
                modalService.confirm({
                    title: $filter('translate')('events.guests.warning'),
                    message: $filter('translate')('events.resume.change_confirm'),
                    onAccept: function () {

                        logService.debug('Container : ...');
                        logService.debug(container);

                        Restangular.all("EventsResume/" + route).post(container).then(function () {

                            toastr.success($filter('translate')('events.resume.modified_successful'));
                            $scope.loadGuests(); $scope.loadChart();

                        });

                    }
                });
            });
        }

        $scope.modifyStatus = function (item, route) {

            changeAssistance(item, route);

        }

            $scope.export = function () {

                const isMainEvent = $scope.selectedAct.isMainEvent;

                if (isMainEvent) {

                    let options = {
                        filters: {
                            EVENT_ID: $stateParams.id,
                            EXPORT_TYPE: "RESUME",
                        }
                    };

                    datasetsService.exportByType("event_resume", options);

                } else {
                
                    let options = {
                        filters: {
                            ACT_ID: $scope.selectedAct.id,
                        }
                    }

                    datasetsService.exportByType("act_resume", options);

                }

            };

        //Cuando salga del events, se destruirá el intervalo.
        $scope.$on("$destroy", function () {
           //  logService.debug("Entra en el destroy del dashboard");
            if (angular.isDefined(intervalLoadInfoDashboard)) {
                $interval.cancel(intervalLoadInfoDashboard);
                intervalLoadInfoDashboard = undefined;
            }
        });

    }])

;